/*eslint-disable */
// @ts-nocheck
if (process.env.NODE_ENV !== 'development') {
  __webpack_public_path__ = `${
    (document.currentScript && document.currentScript.src.split('/cascoon/')[0]) || '//tp.media'
  }/cascoon/`; // eslint-disable-line no-underscore-dangle
}
/* eslint-enable */
